<script setup>
import { sortBy } from 'lodash/lodash';
import { computed } from 'vue';

import CommentInternalMessage from '@/app/community/components/CommentInternalMessage.vue';
import { useCommunityStore } from '@/stores/community';
import { useCommunityCommentsStore } from '@/stores/community-comments';

const communityStore = useCommunityStore();
const commentsStore = useCommunityCommentsStore();

const props = defineProps({
  comment: { type: Object, default: () => ({}) },
  brand: { type: Object, default: undefined },
});

const internalMessages = computed(() =>
  communityStore.formattedInternalMessages.map((internalMessage) => ({
    ...internalMessage,
    text: internalMessage.props.message,
    avatar: {
      label: internalMessage.props.sender.initials,
      tooltip: internalMessage.props.sender.fullName,
    },
    orientation: internalMessage.props.sender.isSenderCurrentUser ? 'reply' : 'receipt',
    variant: 'note',
    date: new Date(internalMessage.createdAt),
  })),
);

const ruleExecutedInternalMessages = computed(() =>
  commentsStore.ruleExecutedInternalMessages.map((record) => ({
    ...record,
    text: record.props.message,
    action: record.props.action,
    orientation: 'reply',
    avatar: {
      icon: 'dash-social',
      variant: 'brand',
    },
    date: record.createdAt,
  })),
);

const privateReplyMessages = computed(() => {
  if (commentsStore.commentDetail?.privateReply) {
    return [
      {
        ...commentsStore.commentDetail.privateReply,
        orientation: 'reply',
        avatar: { image: props.brand?.avatarUrl },
        date: commentsStore.commentDetail.privateReply.createdAt,
      },
    ];
  }
  return [];
});

const combinedInternalMessages = computed(() =>
  sortBy(
    [
      ...internalMessages.value,
      ...ruleExecutedInternalMessages.value,
      ...privateReplyMessages.value,
    ],
    (message) => message.date,
  ),
);
</script>

<template>
  <div v-if="combinedInternalMessages.length" class="dash-flex dash-flex-col dash-gap-4">
    <template v-for="message in combinedInternalMessages" :key="message.id">
      <CommentInternalMessage :message="message" :comment="comment" />
    </template>
  </div>
</template>
